import axios from 'axios';

function getAuthHeader() {
  const token = localStorage.getItem('token');
  if (!token) return {};
  return { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` };
}

export function getConsumoPath(chatPath) {
  if (!chatPath || typeof chatPath !== 'string') return null;
  return chatPath.replace('chat-gemini', 'ia/consumo');
}

export async function fetchConsumoIa(apiBaseUrl, chatPath) {
  const path = getConsumoPath(chatPath);
  if (!apiBaseUrl || !path) return null;
  try {
    const url = apiBaseUrl.replace(/\/$/, '') + path;
    const { data } = await axios.get(url, {
      headers: getAuthHeader(),
      timeout: 10000,
    });
    return data;
  } catch (err) {
    if (err?.response?.status === 404 || err?.response?.status === 501) return null;
    return null;
  }
}
